import { subheading } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

const MdxSubheading: FC<PropsWithChildren> = ({ children }) => {
  const Component = subheading.component.value as FC<PropsWithChildren>;
  return <Component>{children}</Component>;
};

MdxSubheading.displayName = 'MdxSubheading';

export { MdxSubheading };
